// @flow
import { load as loadCore } from '../lib/WasmCache'

declare var require: {
  context(directory: string, useSubdirectories: boolean): void,
  (id: string): ReactRailsUJS,
}

// Support component names relative to this directory:
const componentRequireContext = require.context('components', true)
const ReactRailsUJS = require('react_ujs')
const originalMountComponents = ReactRailsUJS.mountComponents

// eslint-disable-next-line react-hooks/rules-of-hooks
ReactRailsUJS.useContext(componentRequireContext)
ReactRailsUJS.mountComponents = (target) => {
  loadCore()
    .then(() => {
      originalMountComponents.apply(ReactRailsUJS, target)
    })
    .catch((_) => {
      // TODO: render some error page and suggest customer to reach out to CS team
    })
}
